import React, { FC } from 'react'

import { UseFormSetValue, UseFormWatch } from 'react-hook-form/dist/types/form'

import { Checkbox } from 'src/components/atoms/inputs/Checkbox'
import { TableSortableTxt, TableSortType } from 'src/components/molecules'

import { UserAssignProjectFormEntity } from 'src/types'

export type UserAssignProjectSortItemType = 'project' | 'status' | 'role'

type Props = {
  watch: UseFormWatch<UserAssignProjectFormEntity>
  setValue: UseFormSetValue<UserAssignProjectFormEntity>
  sortItem: UserAssignProjectSortItemType
  sortType: TableSortType
  onSelectItem: (newItem: UserAssignProjectSortItemType) => void
  className?: string
}

export const UserAssignProjectListHead: FC<Props> = ({
  watch,
  setValue,
  sortItem,
  sortType,
  onSelectItem,
  className,
}) => {
  const isAllSelected = watch('projects').every(project => project.isSelected)
  const isSomeSelected = watch('projects').some(project => project.isSelected)

  const handleOnClickAllSelect = () => {
    const newProjects = watch('projects').map(project => ({
      ...project,
      isSelected: !isAllSelected,
    }))
    setValue('projects', newProjects)
  }

  return (
    <div className={className}>
      <div className="tw-bg-surface-secondary tw-py-s-1 tw-px-s0">
        <div className="tw-flex tw-items-center tw-gap-s0">
          <Checkbox
            checked={isSomeSelected}
            indeterminate={!isAllSelected && isSomeSelected}
            onChange={handleOnClickAllSelect}
          />
          <div className="tw-w-full">
            <TableSortableTxt
              text="Project"
              isActive={sortItem === 'project'}
              sortType={sortType}
              onSelect={() => onSelectItem('project')}
            />
          </div>
          <div className="tw-w-s5 tw-font-bold tw-shrink-0">
            <TableSortableTxt
              text="Status"
              isActive={sortItem === 'status'}
              sortType={sortType}
              onSelect={() => onSelectItem('status')}
            />
          </div>
          <div className="tw-w-[12.86rem] tw-shrink-0">
            <TableSortableTxt
              text="権限"
              isActive={sortItem === 'role'}
              sortType={sortType}
              onSelect={() => onSelectItem('role')}
            />
          </div>
        </div>
      </div>
    </div>
  )
}
